import { db } from "common/config/Firebase";

const notesCollection = db.collection("notes");

const addNoteUseCase = async (text) => {
  const payload = {
    text,
    done: false,
    createdAt: new Date().getTime(),
    completedAt: null,
  };

  const { id } = await notesCollection.add(payload);
  return id;
};

export default addNoteUseCase;